module.exports = __webpack_public_path__ + "static/media/research-recommendation.dcfc6094.svg";